import api, { unwrap } from './client';

// Flux de trésorerie réels mensuels (Financials) — saisie.
export const getCashActuals = (tenantId, year) =>
  unwrap(api.get(`/financials-cash-actuals/${tenantId}/${year}`));

export const upsertCashActual = (tenantId, year, month, payload) =>
  unwrap(api.put(`/financials-cash-actuals/${tenantId}/${year}/${month}`, payload));
